import { ActivityFilterKey } from '@gripp/shared-logic';
import { ActivityLabelsFilter, DropDownView, FilterType } from '@gripp/shared-ui';
import { View } from 'react-native';

type ActivityLabelsFilterMenuProps = {
  onFilterOpen: () => void;
  onFilterClose: () => void;
  isOpened: boolean;
  anchorRef: React.RefObject<View>;
  type: FilterType;
  filterKey?: ActivityFilterKey;
};

export const ActivityLabelsFilterMenu = ({
  onFilterClose,
  onFilterOpen,
  isOpened,
  anchorRef,
  type,
  filterKey,
}: ActivityLabelsFilterMenuProps) => {
  return (
    <DropDownView
      anchorRef={anchorRef}
      isVisible={isOpened}
      onDismiss={onFilterClose}
    >
      {filterKey && (
        <ActivityLabelsFilter
          goBack={onFilterClose}
          filterKey={filterKey}
          type={type}
        />
      )}
    </DropDownView>
  );
};
